/* eslint-disable react/prop-types */
import {
	IconButton,
	SwipeableDrawer,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

export default function Drawer(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	// Check for dark theme
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	const {
		open,
		setOpen,
		medWidth,
		closeBtnTop,
		children,
		anchor = 'bottom',
		height = 'auto',
		customDetails,
		showCloseBtn = true,
		paperBackground,
		ariaLabelledBy,
		ariaDescribedBy,
		opaqueBackdrop = false,
		flushBottom = false,
	} = props;

	// eslint-disable-next-line no-unused-vars
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event &&
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return;
		}
		setOpen(false);
	};

	const resolvedPaperBackground =
		paperBackground ||
		(isDark ? '#161616' : customDetails?.secondaryColor || '#FFFFFF');

	return (
		<SwipeableDrawer
			anchor={anchor}
			open={open}
			disableEscapeKeyDown={false}
			ModalProps={{
				...(opaqueBackdrop
					? {
							BackdropProps: {
								style: {
									backgroundColor: resolvedPaperBackground,
									opacity: 1,
								},
								sx: {
									backgroundColor: `${resolvedPaperBackground} !important`,
									opacity: '1 !important',
								},
							},
						}
					: {}),
			}}
			PaperProps={{
				elevation: opaqueBackdrop ? 0 : undefined,
				...(ariaLabelledBy
					? {
							role: 'dialog',
							'aria-modal': true,
							'aria-labelledby': ariaLabelledBy,
							...(ariaDescribedBy
								? { 'aria-describedby': ariaDescribedBy }
								: {}),
						}
					: {}),
				style: {
					backgroundColor: resolvedPaperBackground,
					opacity: 1,
					backgroundImage: 'none',
				},
				sx: {
					borderRadius: mobileScreen ? '1rem 1rem 0 0' : '0',
					width: '100%',
					minHeight: height,
					pb: flushBottom ? 0 : '1rem',
					...(flushBottom && {
						display: 'flex',
						flexDirection: 'column',
						maxHeight: 'min(88dvh, 100%)',
						overflow: 'hidden',
					}),
					backgroundColor: `${resolvedPaperBackground} !important`,
					opacity: 1,
					backgroundImage: 'none',
				},
			}}
			onOpen={toggleDrawer('right', true)}
			onClose={toggleDrawer('right', false)}
			disableSwipeToOpen
		>
			{showCloseBtn && (
				<IconButton
					aria-label={t('common.buttons.close')}
					onClick={toggleDrawer('right', false)}
					sx={{
						position: 'absolute',
						right: { xs: '1rem', md: '2rem' },
						top: '1rem',
						width: '2.5rem',
						height: '2.5rem',
						color: isDark ? '#FFFFFF' : theme.palette.primary.main,
						background: isDark ? '#2D2D2D' : theme.palette.primary.light,
					}}
					disableRipple
				>
					<Close />
				</IconButton>
			)}
			{children}
		</SwipeableDrawer>
	);
}
